import { logUsage } from 'owa-analytics';
import { userDate, OwaDate, isAfter, isBefore, now, addMinutes } from 'owa-datetime';

export function shouldUseReadWriteServer(linkCreatedDateTime: string): boolean {
    let isNewlyCreatedLink: boolean = false;
    if (linkCreatedDateTime) {
        try {
            const createdDateTime: OwaDate = userDate(linkCreatedDateTime);
            isNewlyCreatedLink =
                isAfter(createdDateTime, addMinutes(now(), -10)) &&
                isBefore(createdDateTime, now());
        } catch (e) {}

        logUsage('validlinkCreatedDateTime', { isNewlyCreatedLink: isNewlyCreatedLink });
    }

    return isNewlyCreatedLink;
}
